module.exports = __webpack_public_path__ + "files/5e429d8a65863ebe4f9610f39de4c5e1.svg";